import { gql } from "graphql-tag";
import { withApiMutation } from "src/stores/Api";
import {
  addBankAccount,
  addBankAccountVariables,
  createPayment,
  createPaymentVariables,
  paymentSession,
  paymentSessionVariables,
} from "types/code-generator";
import { TypedDocumentNode } from "types/graphql";

const PaymentPayloadFragment = gql`
  fragment PaymentPayload on Payment {
    amount
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
    description
    id
    stripeChargeId
    type
  }
`;

export const CreatePaymentMutation = gql`
  mutation createPayment($data: PaymentCreateInput!) {
    createPayment(data: $data) {
      ...PaymentPayload
    }
  }
  ${PaymentPayloadFragment}
` as TypedDocumentNode<createPayment, createPaymentVariables>;

export const CreatePayment = withApiMutation(CreatePaymentMutation, {
  name: "createPayment",
});

export const PaymentSessionQuery = gql`
  query paymentSession($data: PaymentSessionInput!) {
    paymentSession(data: $data) {
      id
      sessionData
    }
  }
` as TypedDocumentNode<paymentSession, paymentSessionVariables>;

export const AddBankAccountMutation = gql`
  mutation addBankAccount(
    $organizationId: ID!
    $legalEntityId: ID!
    $transferInstrumentId: ID!
  ) {
    addBankAccount(
      organizationId: $organizationId
      legalEntityId: $legalEntityId
      transferInstrumentId: $transferInstrumentId
    )
  }
` as TypedDocumentNode<addBankAccount, addBankAccountVariables>;
